// extracted by mini-css-extract-plugin
export var ai = "ExcerptDetails-module--ai--77e5c";
export var bounty = "ExcerptDetails-module--bounty--5429d";
export var commandline = "ExcerptDetails-module--commandline--c4db6";
export var dataset = "ExcerptDetails-module--dataset--ec323";
export var docs = "ExcerptDetails-module--docs--bc641";
export var doltgres = "ExcerptDetails-module--doltgres--2a19a";
export var dolthub = "ExcerptDetails-module--dolthub--a14d8";
export var doltlab = "ExcerptDetails-module--doltlab--18ba7";
export var featurerelease = "ExcerptDetails-module--featurerelease--4ea2c";
export var generated = "ExcerptDetails-module--generated--d7914";
export var golang = "ExcerptDetails-module--golang--e90ea";
export var hosted = "ExcerptDetails-module--hosted--8a804";
export var integration = "ExcerptDetails-module--integration--b5f43";
export var label = "ExcerptDetails-module--label--fda62";
export var python = "ExcerptDetails-module--python--487f7";
export var reference = "ExcerptDetails-module--reference--ff26e";
export var release = "ExcerptDetails-module--release--83e73";
export var sql = "ExcerptDetails-module--sql--6969f";
export var tagList = "ExcerptDetails-module--tagList--dd990";
export var technical = "ExcerptDetails-module--technical--5b683";
export var timeToRead = "ExcerptDetails-module--timeToRead--3c779";
export var top = "ExcerptDetails-module--top--92664";
export var usecase = "ExcerptDetails-module--usecase--4704f";
export var video = "ExcerptDetails-module--video--71171";
export var web = "ExcerptDetails-module--web--7e7f9";
export var workbench = "ExcerptDetails-module--workbench--e4d74";